
if (!customElements.get('adev-shoppable-banner')) {

    customElements.define('adev-shoppable-banner', class adevShoppableBanner extends HTMLElement {
        constructor() {
            super();
        }

        shopifyCustomizerInit(){
            if (!Shopify.designMode) return;

            document.addEventListener('shopify:block:select', (event) => {
                const blockId = event.detail.blockId;
                const button = this.querySelector(`[data-adev-shoppable-banner="hotspot-button"][data-block-id="${blockId}"]`);

                if (button) {
                    this.openHotspot(button, new Event('click'));
                }
            });
        }

        openHotspot(button, event) {
            event.preventDefault();

            const index = button.dataset.index;
            const blockId = button.dataset.blockId;

            const isOpened = button.classList.contains('is--active');

            if (isOpened) {
                this.closeAll();
                return;
            }

            this.closeAll();

            button.classList.toggle('is--active');

            this.openPopup(blockId);
        }

        closeAll(){
            this.querySelectorAll('[data-adev-shoppable-banner="hotspot-button"].is--active').forEach(btn => {
                btn.classList.remove('is--active');
            });

            this.querySelectorAll('[data-adev-shoppable-banner="hotspot-popup"].is--active').forEach(popup => {
                popup.classList.remove('is--active');
            });
        }

        openPopup(blockId) {
            const popup = this.querySelector(`[data-adev-shoppable-banner="hotspot-popup"][data-block-id="${blockId}"]`);

            popup.classList.toggle('is--active');
        }

        handleResize() {
            this.closeAll();

            this.querySelectorAll('[data-adev-shoppable-banner="hotspot-popup"]').forEach(popup => {
                popup.style.transform = 'translate3d(0, -10px, 0px)';
            });
        }

        connectedCallback() {
            this.querySelectorAll('[data-adev-shoppable-banner="hotspot-button"]').forEach(button => {
                const tooltip = this.querySelector(`[data-adev-shoppable-banner="hotspot-popup"][data-block-id="${button.dataset.blockId}"]`);

                Popper.createPopper(button, tooltip, {
                    placement: 'top',
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 10],
                            },
                        },
                    ],
                });

                button.addEventListener('click', this.openHotspot.bind(this, button));
            });

            this.addEventListener('click', (event) => {
                const isHotspotButton = event.target.closest('[data-adev-shoppable-banner="hotspot-button"]');
                const isHotspotPopup = event.target.closest('[data-adev-shoppable-banner="hotspot-popup"]');

                if (!isHotspotButton && !isHotspotPopup) {
                    this.closeAll();
                }
            });

            this.shopifyCustomizerInit();

            this._onResize = window.adev.Utils.debounce(this.handleResize.bind(this), 100);
            window.addEventListener('resize', this._onResize);
        }

        disconnectedCallback() {
            this.querySelectorAll('[data-adev-shoppable-banner="hotspot-button"]').forEach(button => {
                button.removeEventListener('click', this.openHotspot.bind(this, button));
            });

            window.removeEventListener('resize', this._onResize);
        }

    });
}